import { ViewProductPayload, AddToCartPayload, AnalyticsContext } from "./types"

declare global {
  interface Window {
    fbq: any
    ttq: any
  }
}

interface UserConfig {
  pixelId: string
}

export const facebookPixelPlugin = function facebookPixelPlugin(userConfig: UserConfig) {
  return {
    name: "facebook",
    config: {
      pixelId: userConfig.pixelId,
    },
    initialize: ({ config }: { config: UserConfig }) => {
      appendScript()
      window.fbq("init", config.pixelId)
      //debug(`initialised with id ${config.pixelId}`)
    },
    page: () => {
      window.fbq("track", "PageView")
      debug("PageView tracked")
    },
    track: (context: AnalyticsContext) => {
      const {
        payload: { event, properties },
      } = context

      if ("viewProduct" === event) {
        viewProduct(properties as ViewProductPayload)
        return
      }

      if ("addToCart" === event) {
        addToCart(properties as AddToCartPayload)
        return
      }

      customEvent(event, properties)
    },
    loaded: () => {
      return !!window.fbq
    },
  }
}

const viewProduct = (payload: ViewProductPayload) => {
  const facebookPayload = {
    content_ids: [payload.sku],
    content_name: payload.title,
    content_type: "product",
    currency: payload.currency,
    value: payload.price / 100,
  }

  window.fbq("track", "ViewContent", facebookPayload)

  //debug("ViewContent (product) tracked", facebookPayload)
}

const addToCart = (payload: AddToCartPayload) => {
  const facebookPayload = {
    content_ids: [payload.product.sku],
    content_name: payload.product.title,
    content_type: "product",
    currency: payload.product.currency,
    value: payload.product.price / 100,
  }

  window.fbq("track", "AddToCart", facebookPayload)

  //debug("AddToCart tracked", facebookPayload)
}

const customEvent = (eventName: string, payload: any) => {
  window.fbq("trackCustom", eventName, payload)
  //debug("custom event tracked", { eventName, payload })
}

const debugMode = "development" === process.env.NODE_ENV

const debug = (message: string, context?: any) => {
  if (!debugMode) return
  window.ttq.track("ViewContent", {
    content_id: window.location.pathname,
  })
  context ? console.info(`FACEBOOK PIXEL CODE: ${message}`, context) : console.info(`FACEBOOK PIXEL CODE: ${message}`)
}

// https://developers.facebook.com/docs/facebook-pixel/implementation
const appendScript = () => {
  /* eslint-disable */
  // @ts-ignore prettier-ignore
  ;(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = "2.0"
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js")
  /* eslint-enable */
}
